/**
 * 주어진 ISO 날짜를 원하는 형식으로 포맷하는 함수입니다.
 *
 * @param isoDate - ISO 형식의 날짜 문자열
 * @param format - 포맷 문자열 (기본값: 'MM.DD')
 *   - 'MM.DD': 월.일 (예: '06.18')
 *   - 'YYYY-MM-DD': 년-월-일 (예: '2024-06-18')
 *   - 'DD/MM/YYYY': 일/월/년 (예: '18/06/2024')
 *   - 사용자 정의 포맷에도 대응합니다.
 * @returns 포맷된 날짜 문자열
 */
export const formatDate = (isoDate: string, format: string = 'MM.DD', isUTC: boolean = false): string => {
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date');
  }

  const year = isUTC ? String(date.getUTCFullYear()) : String(date.getFullYear());
  const month = isUTC ? String(date.getUTCMonth() + 1).padStart(2, '0') : String(date.getMonth() + 1).padStart(2, '0');
  const day = isUTC ? String(date.getUTCDate()).padStart(2, '0') : String(date.getDate()).padStart(2, '0');

  return format.replace('YYYY', year).replace('MM', month).replace('DD', day);
};
